import React, { useEffect, useState, useContext } from "react";
import NormaTecnicaControllerContextProvider, {
  NormaTecnicaControllerContext,
} from "../../context/NormaTecnicaControllerContextProvider";
import ClayTable from "@clayui/table";
import HeaderTable from "../../../../../common/components/HeaderTable";
import Loading from "../../../../../common/components/Loading";
import Pagination from "../../../../../common/components/Pagination";
import { splitArray } from "../../../../../common/utils/utilsFunc";
import { CGE } from "../../../../../common/components/CGE";
import arTitles from "../../../../../common/services/mock/title.json";
import { getPathName } from "../../../../../common/utils/utilsFunc";



function NormaTecnicaController({ props, qtdRowPage}) {
  const [state] = useContext(NormaTecnicaControllerContext);
  const [loading, setLoading] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [rowPage, setRowPageList] = useState(10);
  const [currentArray, setCurrentArray] = useState([]);
  const [auxArray, setAuxArray] = useState([]);
  const [newArrTitle, setNewArrTitle] = useState(null);

  let error = null;

  function setRowPage(nPage) {
    setActivePage(1);
    setRowPageList(Number(nPage));
  }

  useEffect(() => {
    setNewArrTitle(arTitles[getPathName()]?.map((item) => item.label));
  }, [getPathName()]);

  React.useEffect(() => {
    let arrayOfarrays = [];
    arrayOfarrays = splitArray(auxArray, rowPage);
    setCurrentArray(arrayOfarrays[activePage - 1]);
  },[activePage, auxArray, rowPage]);

  React.useEffect(() => {
    if (!state.dataTable) {
      setLoading(true);
    } else {
      const objResponse = state.dataTable;
      setLoading(false);

      if (objResponse?.data?.dadosContatoUsuarios?.length > 0) {
        setAuxArray(objResponse?.data?.dadosContatoUsuarios);

      } else if (objResponse?.data?.dadosContatoUsuarios?.length === 0) {
        props.setGlobalAlert(
          "No se encontraron registros",
          "warning",
          true,
          "Advertencia"
        );
        setAuxArray([]);
      } else {
        props.setGlobalAlert(
          "El servicio no está disponible actualmente, intente más tarde.",
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.dataTable]);

  let propsTable = {
    fileName: props.title_norma_tecnica,
    title: props.title_norma_tecnica,
    auxArray: auxArray,
    arTitles: arTitles,
    disabled: auxArray?.length > 0 ? false : true,
    setActivePage: setActivePage,
    qtdRowPage: qtdRowPage,
    setRowPage: setRowPage,
    rowPage: rowPage,
    activePage: activePage,
    excelBtn: true,
    showPagination: false,
  }

  var panelFooter = (
    <>
      <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
          <Pagination
            items={auxArray}
            onChangePage={setActivePage}
            qtdRowPage={qtdRowPage}
            setRowPage={setRowPage}
            pageSize={rowPage}
            currentPg={activePage}
          />
        </div>
    </>
  );

  return (
    <div>
      <CGE.Panel footerContent={panelFooter}>
        <HeaderTable props={propsTable} />
        <ClayTable
            class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
            id="table-to-xls"
          >
            <ClayTable.Head>
              <ClayTable.Row>
                {newArrTitle?.map((title) => {
                  return (
                    <ClayTable.Cell headingCell className="clientCell font-weight-bold">
                      {title}
                    </ClayTable.Cell>
                  );
                })}
              </ClayTable.Row>
            </ClayTable.Head>
            <ClayTable.Body>
              {auxArray ? (
                auxArray?.map((obj) => {
                  return (
                    <ClayTable.Row className="tableRow">
                      {Object.keys(obj).map((index) => {
                        return (
                          <ClayTable.Cell
                            className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                            title={index}
                          >
                            {obj[index] === true ? (
                              <span>Si</span>
                            ) : obj[index] === false ? (
                              <span>No</span>
                            ) : (
                              obj[index]
                            )}
                          </ClayTable.Cell>
                        );
                      })}
                    </ClayTable.Row>
                  );
                })
              ) : (
                <ClayTable.Row>
                  <ClayTable.Cell
                    colspan={newArrTitle?.length}
                    className="text-no-results  font-weight-bold"
                  >
                    {!loading}
                  </ClayTable.Cell>
                </ClayTable.Row>
              )}
            </ClayTable.Body>
          </ClayTable>

        {loading && <Loading />}
      </CGE.Panel>
    </div>
  );
}

const NormaTecnicaControllerWithProvider = ({ props, qtdRowPage }) => (
  <NormaTecnicaControllerContextProvider>
    <NormaTecnicaController props={props} qtdRowPage={qtdRowPage} />
  </NormaTecnicaControllerContextProvider>
);
export default NormaTecnicaControllerWithProvider;